import { useLang } from "@/contexts/LanguageContext";
import { t } from "@/translations";

export default function Footer() {
  const { lang } = useLang();
  const tr = t[lang].footer;

  return (
    <footer className="w-full bg-[#f1f8e9] border-t border-[#c8e6c9]">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-10 justify-between">
          {/* Left: Logo + legal links + socials + payment */}
          <div className="flex flex-col gap-5 flex-1">
            <img
              src="https://fs02.getcourse.ru/fileservice/file/download/a/47075/sc/447/h/a47e04b993b974bb1dd9befa9fa8e2fd.png"
              alt="ABASCHOOL"
              className="h-12 object-contain object-left"
            />

            <div className="flex flex-col gap-1 text-sm text-gray-600">
              <a href="https://aba-school.ru/oferta" target="_blank" rel="noopener noreferrer" className="hover:text-[#4caf50] transition-colors cursor-pointer">
                {tr.publicOffer}
              </a>
              <a href="https://aba-school.ru/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-[#4caf50] transition-colors cursor-pointer">
                {tr.privacy}
              </a>
              <a href="https://aba-school.ru/consent" target="_blank" rel="noopener noreferrer" className="hover:text-[#4caf50] transition-colors cursor-pointer">
                {tr.consent}
              </a>
              <p className="text-gray-500 text-xs mt-1">{tr.registration}</p>
            </div>

            {/* Socials */}
            <div className="flex items-center gap-3">
              <a href="https://t.me/abaschooltg" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:border-[#4caf50] transition-colors cursor-pointer">
                <i className="ri-telegram-line text-[#229ED9] text-lg" />
              </a>
              <a href="https://vk.com/abaschool" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:border-[#4caf50] transition-colors cursor-pointer">
                <i className="ri-vk-line text-[#4680C2] text-lg" />
              </a>
              <a href="mailto:info@aba-school.ru" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:border-[#4caf50] transition-colors cursor-pointer">
                <i className="ri-mail-line text-gray-600 text-lg" />
              </a>
              <a href="https://www.youtube.com/@aba-school" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:border-[#4caf50] transition-colors cursor-pointer">
                <i className="ri-youtube-line text-[#FF0000] text-lg" />
              </a>
            </div>

            {/* Payment icons */}
            <div className="flex items-center gap-3 flex-wrap">
              <img src="https://fs.getcourse.ru/fileservice/file/download/a/47075/sc/186/h/13519a0ddca772af1932f938bca22b68.png" alt="VISA" className="h-6 object-contain" />
              <img src="https://fs.getcourse.ru/fileservice/file/download/a/47075/sc/0/h/69f4fd43f1699525e1901233cc30611b.png" alt="MasterCard" className="h-6 object-contain" />
              <img src="https://fs.getcourse.ru/fileservice/file/download/a/47075/sc/400/h/405f2ce0129e7006805925a20940434a.png" alt="MIR" className="h-6 object-contain" />
              <img src="https://fs.getcourse.ru/fileservice/file/download/a/47075/sc/182/h/6fb1aee021737419561bcd55b22cdc38.jpg" alt="SBP" className="h-6 object-contain" />
            </div>
          </div>

          {/* Right: Company info */}
          <div className="flex flex-col gap-2 text-sm text-gray-600 lg:text-right max-w-xs">
            <p className="font-semibold text-gray-800">{tr.companyName}</p>
            <p>{tr.legalAddress}</p>
            <p>{tr.address1}</p>
            <p>{tr.address2}</p>
            <p>{tr.inn}</p>
            <p>{tr.ogrn}</p>
            <p>{tr.account}</p>
            <p>{tr.bank}</p>
            <p>{tr.corrAccount}</p>
            <p>{tr.bik}</p>
            <p className="mt-3 text-gray-400 text-xs">{tr.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
